import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  ViewChild,
} from "@angular/core";
import * as THREE from "three";
import { DragControls } from "three/examples/jsm/controls/DragControls.js";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PreviewComponent } from "../preview/preview.component";

export const bounds = {
  minX: -19,
  maxX: 19,
  minZ: -15,
  maxZ: 15,
};

@Component({
  selector: "app-three-js",
  templateUrl: "./three-js.component.html",
  styleUrls: ["./three-js.component.css"],
})

export class ThreeJsComponent implements OnInit, AfterViewInit {
  @Input() fromParent: any;
  @ViewChild("threeJscontent", { static: true })
  container!: ElementRef<HTMLElement>;
  private renderer!: THREE.WebGLRenderer;
  private scene!: THREE.Scene;
  private camera!: THREE.PerspectiveCamera;
  private circles: THREE.Mesh[] = [];
  private controls!: DragControls;
  private aspect: number = 0;
  private width: number = 0;
  private height: number = 0;
  imagePath = "assets/images/football-ground.png";
  positions = [
    { x: 0, y: 1, z: -1 },
    { x: -1.18, y: 1, z: -1.4 },
    { x: 1.18, y: 1, z: -1.4 },
    { x: -2.5, y: 1, z: -1.4 },
    { x: 2.5, y: 1, z: -1.4 },
    { x: 0.09549999, y: 1, z: -5.26 },
    { x: 2.54, y: 1, z: -5.9 },
    { x: -11.16, y: 1, z: -1.66 },
    { x: -16.23, y: 1, z: -0.9 },
    { x: 16.23, y: 1, z: -1.66 },
    { x: 3.62, y: 1, z: -0.9 },
  ];
  cartureImg = "";
  originId: string = "";
  origin: string = "";

  // @Input() position!: { x: number; y: number; z: number };
  // // Emit an updated position back to the parent
  // @Output() positionChange = new EventEmitter<{ x: number; y: number; z: number }>();
  @Output() updatedPositionData = new EventEmitter();
  @Input() position !: any;


  constructor(@Optional() public activeModal: NgbActiveModal,
    private modalService: NgbModal) { }

  ngOnChanges(changes: any) {
    //console.log(changes, 'on load')
    if (changes && changes?.position) {
      this.positions = changes?.position.currentValue;
    }
  }

  ngOnInit(): void {
    if (this.fromParent) {
      this.originId = this.fromParent.originId;
      this.origin = this.fromParent.origin;
      this.positions = this.fromParent.positions;
    }
  }

  ngAfterViewInit() {
    this.width = this.container.nativeElement.offsetWidth;
    this.height = this.container.nativeElement.offsetHeight;
    this.aspect = this.width / this.height;

    this.initRenderer();
    this.initScene();
    this.initCamera();
    this.initLight();
    this.loadField();
    this.createShapes();
    this.initControls();
    this.animate();
  };

  initRenderer() {
    this.renderer = new THREE.WebGLRenderer();
    this.renderer.setPixelRatio(this.aspect);
    this.renderer.setSize(this.width, this.height);
    this.container.nativeElement.appendChild(this.renderer.domElement);
  };

  initScene() {
    this.scene = new THREE.Scene();
  };

  initCamera() {
    this.camera = new THREE.PerspectiveCamera(45, this.aspect, 1, 200);
    this.camera.position.set(0, 45, 0);
    this.camera.lookAt(0, 0, 0);
  };

  initLight() {
    const light = new THREE.HemisphereLight(0xffffbb, 0x080820, 1);
    this.scene.add(light);
  };

  loadField() {
    const loader = new THREE.TextureLoader();
    loader.load(this.imagePath, (texture) => {
      const fieldGeometry = new THREE.PlaneGeometry(70, 90);
      const fieldMaterial = new THREE.MeshBasicMaterial({ map: texture });
      const field = new THREE.Mesh(fieldGeometry, fieldMaterial);
      field.rotation.x = -Math.PI / 2; // Rotate the field to lay flat
      this.scene.add(field);
    });
  };

  createShapes() {
    this.circles = [];
    const circleGeometry = new THREE.CircleGeometry(0.4, 50);
    const circleMaterial = new THREE.MeshBasicMaterial({
      color: "#0467DE",
    });


    for (let i = 0; i < this.positions?.length; i++) {
      const pos = this.positions[i];
      const circle = new THREE.Mesh(circleGeometry, circleMaterial);
      circle.position.set(pos.x, pos.y, pos.z * -1);
      circle.rotation.x = -Math.PI / 2;
      this.circles.push(circle);
      this.scene.add(circle);
    }
  };

  initControls() {
    this.controls = new DragControls(
      this.circles,
      this.camera,
      this.renderer.domElement
    );

    this.controls.addEventListener("drag", (event) => {
      const object = event.object;
      object.position.x = Math.max(
        bounds.minX,
        Math.min(bounds.maxX, object.position.x)
      );
      object.position.z = Math.max(
        bounds.minZ,
        Math.min(bounds.maxZ, object.position.z)
      );
    });

    this.controls.addEventListener("dragstart", (event) => {
      const mesh = event.object as THREE.Mesh; // Cast to THREE.Mesh
      if (mesh.material instanceof THREE.Material) {
        mesh.material.opacity = 0.5;
      }
    });

    this.controls.addEventListener("dragend", (event) => {
      const mesh = event.object as THREE.Mesh; // Cast to THREE.Mesh
      if (mesh.material instanceof THREE.Material) {
        mesh.material.opacity = 1;
      }

      var _updatedPostion: any[] = [];

      this.circles.forEach(element => {
        _updatedPostion.push({
          x: element.position.x,
          y: element.position.y,
          z: element.position.z
        });
      });

      this.updatedPositionData.emit(_updatedPostion);
    });
  };

  animate() {
    setTimeout(() => {
      this.renderer.setAnimationLoop(() => {
        this.renderer.render(this.scene, this.camera);
      });
    }, 1000)
  };

  closeModal(sendData: any) {
    this.activeModal.close(sendData);
  };

  capture_ground() {
    // Ensure the renderer is attached and the scene is rendered
    this.animate(); // Start the rendering loop

    // Allow a brief moment for the canvas to update
    setTimeout(() => {
      // Stop the rendering loop
      this.renderer.setAnimationLoop(null);

      // Render the scene once more before capturing the screenshot
      this.renderer.render(this.scene, this.camera);

      const dataUrl = this.renderer.domElement.toDataURL('image/png');
      const link = document.createElement('a');
      this.cartureImg = dataUrl;
      this.modalService.dismissAll("");
      const modalRef = this.modalService.open(PreviewComponent, {
        centered: true,
        size: "xl",
      });
      let obj = {
        originId: this.originId,
        origin: this.origin,
        captureImg: dataUrl,
      };
      modalRef.componentInstance.fromParentPrevieData = obj;
      // Restart the rendering loop to continue normal rendering
      this.animate();
    }, 1000); // Adjust the delay if necessary
  };

  update() {
    let _data = {
      changedPositions: [] as {
        x: number, y: number, z: number
      }[], // Array to hold changed positions
      updatedPosition: true // Separate string property
    };
    this.circles.forEach(element => {
      _data.changedPositions.push({
        x: element.position.x,
        y: element.position.y,
        z: element.position.z
      });
    });
    this.activeModal.close(_data);
  };
}
